import * as io from 'io-ts';

import { nullableArrayOfStrings, nullableNumber, nullableString } from './commonTypes';
import { responseDecoder } from './TOEncoderDecoder';

export const TmplFieldTODecoder = io.type({
  n: io.string,
  typ: io.number,
  v: io.string,
  l: nullableArrayOfStrings,
  //extra values/words
  el: nullableArrayOfStrings,
  w: nullableNumber,
  h: nullableNumber,
  title: nullableString,
  comment: nullableString,
});

export type TmplFieldTO = io.TypeOf<typeof TmplFieldTODecoder>;

export const tmplFieldTOResponseDecoder = responseDecoder<TmplFieldTO>(TmplFieldTODecoder);
